import ukFlag from '@/icons/uk-flag-icon.svg'
import usaFlag from '@/icons/usa-flag-icon.svg'
import auFlag from '@/icons/australia-flag-icon.svg'
import caFlag from '@/icons/canada-flag-icon.svg'

const flagPresets = [
  {
    icon: {
      url: usaFlag,
      alt: 'United States Flag Icon'
    },
    locale: {
      country: 'US',
      language: 'en'
    }
  },
  {
    icon: {
      url: caFlag,
      alt: 'Canada Flag Icon'
    },
    locale: {
      country: 'CA',
      language: 'en'
    }
  },
  {
    icon: {
      url: ukFlag,
      alt: 'United Kingdom Flag Icon'
    },
    locale: {
      country: 'GB',
      language: 'en'
    }
  },
  {
    icon: {
      url: auFlag,
      alt: 'Australia Flag Icon'
    },
    locale: {
      country: 'AU',
      language: 'en'
    }
  }
]

export type FlagButtonGroupProps = {
  onClickFlag?: (locale: { country: string; language: string }) => void
  selectedCountry: string
  bodyText?: string
}

export default function FlagButtonGroup({
  onClickFlag,
  bodyText = 'For the best customer experience and pricing, visit our local online store.'
}: FlagButtonGroupProps) {
  return (
    <div className='flex flex-col gap-4'>
      <span className='text-center text-sm'>{bodyText}</span>
      <div className='grid grid-cols-4 gap-8 self-center'>
        {flagPresets.map(({ locale, icon }) => (
          <button
            title={`${locale.language}-${locale.country}`}
            key={locale.country}
            className='flex items-center justify-center'
            onClick={e => {
              e.preventDefault()
              onClickFlag?.(locale)
            }}>
            <img
              src={icon.url}
              alt={icon.alt}
              className='h-full max-h-12 shadow-md shadow-deep-ocean-blue/[.12] transition-all duration-200 ease-in-out hover:scale-110 hover:shadow-lg'
            />
          </button>
        ))}
      </div>
    </div>
  )
}
